import { setLoaderComplete, setLoaderStart } from "../loader/loader"
import { updateBaseFareMutation, getCategoryPricingQuery, getUserCategoryQuery } from "../../lib/graphql";

import showToaster from "../../helpers/toastrMessgaes/showToaster";
import { closeBaseFareModal } from "./modalActions";

export function updateBasePriceAction(values) {

    return async (dispatch, getState, { client }) => {

        dispatch(setLoaderStart('updateBasePrice'))

        const { subCategoryId, baseFare, categoryId, profileId, currency } = values
        const { data } = await client.mutate({
            mutation: updateBaseFareMutation,
            variables: {
                subCategoryId: Number(subCategoryId),
                baseFare: parseFloat(baseFare),
                categoryId: Number(categoryId),
                profileId: Number(profileId),
                currency: currency
            },
            refetchQueries: [{
                query: getCategoryPricingQuery,
                variables: {
                    categoryId: Number(categoryId)
                },
                fetchPolicy: 'network-only'
            },
            {

                query: getUserCategoryQuery,
                variables: {
                    profileId: Number(profileId),
                },
                fetchPolicy: 'network-only'
            }
            ]
        })

        dispatch(setLoaderComplete("updateBasePrice"))

        if (data?.updateBasePrice?.status == 200) {
            showToaster({ messageId: 'addedBaseFare', toasterType: 'success' });
            dispatch(closeBaseFareModal())
        } else {
            showToaster({ messageId: 'failedBaseFare', requestContent: data?.updateBasePrice?.errorMessage, toasterType: 'error' });
        }

    }

}